import React, { useRef, useEffect, useState } from 'react';
import { Canvas, useFrame, useThree } from '@react-three/fiber';
import { Text } from '@react-three/drei';

import GlfLoader from './GltfLoader';

export default function Lable({ position, children }) {
  const ref = useRef();
  const markerref = useRef();

  const { size } = useThree();
  const [fontSize, setFontSize] = useState(0);

  useEffect(() => {
    const vw = size.width / 100; // 1vw is equal to 1% of viewport width
    const calculatedFontSize = 0.5* vw; // Adjust as needed
    setFontSize(calculatedFontSize);
  }, [size.width]);

  // Update rotation to face the camera in each frame
  useFrame(({ camera }) => {
    // ref.current.lookAt(camera.position);
    // const { quaternion } = borderRef.current;
    // ref.current.quaternion.copy(quaternion); 
    // borderRef.current.quaternion.copy(camera.quaternion);
    ref.current.lookAt(camera.position);
    markerref.current.lookAt(camera.position);
  });

  return (
    <group position={position}>
      {/* Square border */}
      {/* <mesh ref={borderRef} position={[0, 0, 0]} scale={borderScale}>
        <planeGeometry args={[1, 0.5]} />
        <meshBasicMaterial color="red" />
      </mesh> */}
<mesh ref={markerref} position={[0,-1,0]} scale={[2.1,1.6,1.2]}>
      <GlfLoader MeshPath={process.env.PUBLIC_URL + "/Geo/marker.glb"} />
      </mesh>
      {/* Text */}
      <Text
        ref={ref}
        position={[0, 0, 5]}
        fontSize={fontSize}
        color="grey"
        anchorX="center"
        anchorY="middle"
      >
        {children}
      </Text>
    </group>
  );
};
